<span id="legislacao"></span>
<div class="content">
  <div>
    <h2>Legislação</h2>
  </div>
  <div class="card">
    <div class="container">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="filtro"
        name="search"
        placeholder="Digite algo..."
        autocomplete="off"
      />
      <div class="container-buttons">
        <button class="button-search" (click)="search()">PESQUISAR</button>
        <button class="button-clean" (click)="clean()">LIMPAR</button>
      </div>
    </div>
    <table>
      <tbody part="body">
        <tr *ngFor="let arquivo of filesPaginated">
          <td>
            <span class="file-title">{{ arquivo.title | titlecase }}</span>
            <div class="container-images">
              <a [href]="'assets/files/' + arquivo.fileName" [download]="arquivo.fileName">
                <img
                  src="../../../assets/images/icons/download-blue.svg"
                  alt="Baixar arquivo"
                />
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="paginacao">
      <mat-paginator
        (page)="handlePageEvent($event)"
        [pageSizeOptions]="[10]"
        [length]="length"
        hidePageSize="true"
        aria-label="Selecione a página"
      >
      </mat-paginator>
    </div>

  </div>

</div>
